/* eslint-disable react/jsx-pascal-case */
/* eslint-disable react-hooks/rules-of-hooks */
import SaveOutlinedIcon from "@mui/icons-material/SaveOutlined";
import { Box, Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, IconButton, Tab, Tabs } from "@mui/material";
import Grid from "@mui/material/Grid2";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { ErrorComponent } from "src/shared/pages/error";
import Button_circle from "../../../../../../shared/components/button_circle";
import { WrapMain } from "../../../../../../shared/modules/wrap_main";
import FieldsViews from "./components/fieldsViews/fieldsViews";
import InfoHeader from "./components/infoHeader/infoHeader";
import { Requirements } from "./components/requirements/requirements";
import TaskForm from "./components/taskForm/taskForm";
import { getGroupAssignedConfig, getListForConfigTask, getListOfLocationsByProject, getListOfUsers, getTaskDataByid } from "src/shared/util/requestDataServer";
import { Task } from "./interface";
import './styles.scss'
import { useDispatch } from "src/stateManagement/redux";
import { updateTask } from "src/stateManagement/redux/slices/planificacion/asynReducer";
import DeleteIcon from '@mui/icons-material/Delete';
import { deletePlanningActivity } from "src/shared/util/deleteDateFromServer";
import { LoadingComponent } from "src/shared/components/loading";
import { updatePlanningActivity } from "src/shared/util/updateDataServer";
import { VehicleInfo } from "./components/vehicleInfo/vehicleInfo";

interface ListOfUsers {
    id: string;
    label: string;
}

interface TabPanelProps {
    children?: React.ReactNode;
    index: number;
    value: number;
}

function CustomTabPanel(props: TabPanelProps) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box sx={{ padding: "15px 0px" }}>{children}</Box>
            )}
        </div>
    );
}

function a11yProps(index: number) {
    return {
        id: `simple-tab-${index}`,
        "aria-controls": `simple-tabpanel-${index}`,
    };
}

const info = () => {

    const dispatch = useDispatch();

    const { id } = useParams<{ id: string }>();

    const [task, setTask] = useState<Task | undefined>(undefined);

    const [ListOfUsers, setListOfUsers] = useState<ListOfUsers[]>([]);

    const [listForConfig, setlistForConfig] = useState<any>(undefined)

    const [listOfLocationForProject, setListOfLocationForProjectId] = useState<any[]>([])

    const [openDeleteModal, setOpenDeleteModal] = useState(false);

    const [loading, setLoading] = useState(false)

    const [groupAssignedConfig, setGroupAssignedConfig] = useState<any>()

    const handleGoToDashboard = () => {
        navigate("/gto/dashboard/1");
    };

    useEffect(() => {
        getGroupAssignedConfig().then((data) => {
            setGroupAssignedConfig(data)
        })
    }, [])

    useEffect(() => {

        let fieldCode = '0'

        if (task?.projectId && task?.projectId !== '') {
            const field = groupAssignedConfig?.field.find((x: any) => x.id === task?.projectId)
            if (field) {
                fieldCode = field.code.toString().padStart(1, '0')
            }
        }

        let activityCode = '0'
        if (task?.tecnology && task?.tecnology !== '') {
            const activity = groupAssignedConfig?.activity.find((x: any) => x.name === task?.tecnology)
            if (activity) {
                activityCode = activity.code.toString().padStart(2, '0')
            }
        }

        let squadCode = task?.cuadrillaNumber ? task?.cuadrillaNumber.toString().padStart(1, '0') : ''

        const groupAssigned = `${fieldCode}${activityCode}${squadCode}`

        if (groupAssigned) {
            setTask(task ? { ...task, groupAssigned } : undefined)
        }

    }, [task?.projectId, task?.cuadrillaNumber, task?.tecnology, groupAssignedConfig])


    useEffect(() => {
        if (task?.projectId) {
            getListOfLocationsByProject(task?.projectId).then((data) => {
                setListOfLocationForProjectId(data)
            })
        }
    }, [task?.projectId])


    useEffect(() => {

        getListForConfigTask().then((data) => {
            setlistForConfig(data)
        })

        getListOfUsers().then((data) => {
            const listOfUsersFromServer: any[] = [];
            if (!data) {
                return;
            }
            data.forEach((element: any) => {
                listOfUsersFromServer.push({
                    id: element.id,
                    label: element.name,
                });
            });
            setListOfUsers(listOfUsersFromServer);
        });


        if (id === `0`) {
            return
        }

        if (id) {
            getTaskDataByid(id).then((data) => {
                setTask(data)
            })
        } else {
            handleGoToDashboard()
        }
    }, [id])


    const onChangevalue = (value: any, label: any) => {

        let activeTask = task

        if (!activeTask) {
            activeTask = {
                projectId: "",
                cuadrillaNumber: 0,
                type: "",
                advance: 0,
                status: "",
                description: "",
                target: 0,
                groupAssigned: "",
                assignedUserId: "",
                asigneedUserName: "",
                approverUserId: "",
                approverUserName: "",
                tecnology: "",
                requirements: [],
                fieldActivities: [],
            }
        }

        if (value && typeof value === 'object' && 'format' in value) {
            value = value.format('YYYY-MM-DD');
        }

        if (label === "tecnology") {
            const meta = listForConfig?.tecnologia.find((element: any) => element.label === value)?.target
            if (meta) {
                activeTask["target"] = meta
            }
        }


        if (label === "requirements" && Array.isArray(value) && value.length > 0) {
            activeTask["target"] = value.length
        }

        setTask(activeTask ? { ...activeTask, [label]: value } : undefined)
    }


    const onSaveTask = () => {
        if (task) {
            setLoading(true)
            updatePlanningActivity(task).then((data) => {
                if (data) {
                    dispatch(updateTask(data))
                    navigate('/gto/dashboard/1', { state: { from: 'taskupdated' } })
                }
            }
            ).finally(() => {
                setLoading(false)
            })
        }
    }

    const handleDeleteTask = () => {

        if (id) {
            setOpenDeleteModal(false)
            setLoading(true)
            deletePlanningActivity(id).then((data) => {
                if (data) {
                    navigate('/gto/dashboard/1', { state: { from: 'taskdeleted' } })
                }
            }
            ).finally(() => {
                setLoading(false)
            })
        }
    }


    const navigate = useNavigate();
    const [value, setValue] = useState(0);
    const handleChange = (event: React.SyntheticEvent, newValue: number) => {
        setValue(newValue);
    };
    return (
        <WrapMain>
            <>
                {loading && <LoadingComponent label="Procesando ......." />}
                {/* Dialogo */}
                <Dialog
                    open={openDeleteModal}
                    onClose={() => setOpenDeleteModal(false)}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogTitle id="alert-dialog-title">
                        {"Desea eliminar la tarea?"}
                    </DialogTitle>
                    <DialogContent>
                        <DialogContentText id="alert-dialog-description">
                            Esta acción no se puede deshacer
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={() => setOpenDeleteModal(false)}>Cancelar</Button>
                        <Button
                            onClick={handleDeleteTask}
                            autoFocus
                            sx={{
                                backgroundColor: "#d32f2f",
                                color: "#fff",
                                "&:hover": {
                                    backgroundColor: "#9a0007",
                                },
                            }}
                        >
                            Borrar
                        </Button>
                    </DialogActions>
                </Dialog>
                {/* body */}
                <Box
                    sx={{
                        display: "flex",
                        flexDirection: "column",
                        width: "100%",
                    }}
                >
                    <Box className="planning_task_container_header" sx={{
                        borderBottom: "3px solid #129ED3",
                        paddingBottom: "10px",
                        marginRight: "30px",
                        marginLeft: "30px",
                    }}>
                        <Box className="planning_task_container_header_left">
                            <Button_circle
                                icon="/assets/icons/back.svg"
                                iconHeight={35}
                                iconWidth={35}
                                onClick={() =>
                                    handleGoToDashboard()
                                }
                            />
                            <Box className="planning_task_container_container_title">Volver</Box>
                        </Box>
                        <Box>
                            <IconButton
                                aria-label="delete"
                                onClick={() => setOpenDeleteModal(true)}
                                sx={{
                                    backgroundColor: "#d32f2f",
                                    color: "#fff",
                                    ml: 2,
                                    "&:hover": {
                                        backgroundColor: "#9a0007",
                                    },
                                }}
                            >
                                <DeleteIcon />
                            </IconButton>
                            <IconButton
                                aria-label="delete"
                                onClick={() => onSaveTask()}
                                sx={{
                                    backgroundColor: "#03365e",
                                    color: "#fff",
                                    ml: 2,
                                    "&:hover": {
                                        backgroundColor: "#129ED3",
                                    },
                                }}
                            >
                                <SaveOutlinedIcon />
                            </IconButton>
                        </Box>

                    </Box>
                    <Box sx={{ width: "100%" }}>
                        <Grid container spacing={2} sx={{ padding: "0px 50px" }}>
                            <Grid size={12}>
                                {/* <Box
                                    component="div"
                                    sx={{
                                        borderBottom: "3px solid #129ED3",
                                        mt: 2,
                                    }}
                                /> */}
                            </Grid>
                            <Grid size={12}>
                                <InfoHeader
                                    task={task}
                                    ListOfUsers={ListOfUsers}
                                    onChange={onChangevalue}
                                />
                            </Grid>
                            <Grid size={12}>
                                <Box>
                                    <Box
                                        sx={{
                                            borderBottom: 1,
                                            borderColor: "divider",
                                        }}
                                    >
                                        <Tabs
                                            value={value}
                                            onChange={handleChange}
                                            aria-label="basic tabs example"
                                        >
                                            <Tab label="Informacion General" {...a11yProps(0)} />
                                            {/* <Tab label="Chats" {...a11yProps(1)} /> */}
                                            <Tab
                                                label="Vistas de campo"
                                                {...a11yProps(1)}
                                            />
                                            <Tab
                                                label="Requerimientos"
                                                {...a11yProps(2)}
                                            />
                                            <Tab
                                                label="Gerenciamiento"
                                                {...a11yProps(3)}
                                            />
                                            {/* <Tab
                                                label="Documentos"
                                                {...a11yProps(4)}
                                            /> */}
                                        </Tabs>
                                    </Box>

                                    <CustomTabPanel value={value} index={0}>
                                        <TaskForm task={task} listForConfig={listForConfig} onChange={onChangevalue} />
                                    </CustomTabPanel>

                                    {/* <CustomTabPanel value={value} index={1}>
                                        <ErrorComponent
                                            type="403"
                                            infoPage="Módulo No Disponible"
                                        />
                                    </CustomTabPanel> */}

                                    <CustomTabPanel value={value} index={1}>
                                        <FieldsViews task={task} listForConfig={listForConfig} onChange={onChangevalue} />
                                    </CustomTabPanel>
                                    <CustomTabPanel value={value} index={2}>
                                        <Requirements task={task} listForConfig={listForConfig} onChange={onChangevalue} listOfLocationForProject={listOfLocationForProject} />
                                    </CustomTabPanel>
                                    <CustomTabPanel value={value} index={3}>
                                        <VehicleInfo task={task} />
                                    </CustomTabPanel>
                                    {/* <CustomTabPanel value={value} index={3}>
                                        <ErrorComponent
                                            type="403"
                                            infoPage="Módulo No Disponible"
                                        />
                                    </CustomTabPanel> */}
                                </Box>
                            </Grid >
                        </Grid >
                    </Box >
                </Box >
            </>
        </WrapMain >
    );
};

export default info;


